import React, { useState } from 'react';

export const LoggedInUserDetails = React.createContext();

// export const LoggedInUserProvider = LoggedInUserDetails.Provider;
// export const LoggedInUserDetailsConsumer = LoggedInUserDetails.Consumer;

const LoggedInUserProvider = (props) => {

    const [loggedInUserInfo, setLoggedInUserInfo] = useState(() => {
        return {
            logInStatus: false,
            roleModuleAccess: [],
            isLanguageChanged: false,
            defaultEntity: ''
        }
    });

    return (
        <LoggedInUserDetails.Provider value={{ loggedInUserInfo, setLoggedInUserInfo }}>
            {props.children}
        </LoggedInUserDetails.Provider>
    );

}

export default LoggedInUserProvider;